// Structured Data (JSON-LD) para SEO
// Schema.org markup para melhor ranqueamento no Google

export const getOrganizationSchema = (url = 'https://www.veritux.com.br') => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Veritux ERP',
  url: url,
  logo: `${url}/logo.png`,
  description: 'Sistema ERP completo para pequenas e médias empresas. Controle total, insights em tempo real e crescimento previsível.',
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'Atendimento ao Cliente',
    availableLanguage: 'Portuguese',
    areaServed: 'BR'
  },
  sameAs: [
    // Adicione links para redes sociais quando disponíveis
    // 'https://www.facebook.com/veritux',
    // 'https://www.linkedin.com/company/veritux',
    // 'https://www.instagram.com/veritux'
  ],
  address: {
    '@type': 'PostalAddress',
    addressCountry: 'BR'
  }
});

export const getSoftwareApplicationSchema = (url = 'https://www.veritux.com.br') => ({
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Veritux ERP',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Windows',
  offers: {
    '@type': 'Offer',
    price: '197',
    priceCurrency: 'BRL',
    priceValidUntil: '2026-12-31',
    availability: 'https://schema.org/InStock',
    url: url
  },
  description: 'Sistema ERP completo com gestão financeira, controle de estoque, vendas, produção de vestuário e muito mais.',
  featureList: [
    'Gestão Financeira Completa',
    'Controle de Estoque',
    'API REST para integrações',
    'Produção de Vestuário',
    'Dashboards Inteligentes',
    'Emissão de NF-e',
    'Automações',
    'Aplicativo para Windows'
  ],
  screenshot: `${url}/screenshot.jpg`,
  softwareVersion: '1.0',
  releaseNotes: 'Sistema completo de gestão empresarial'
});

export const getWebSiteSchema = (url = 'https://www.veritux.com.br') => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Veritux ERP',
  url: url,
  description: 'O ERP que entrega controle total, insights em tempo real e crescimento previsível para sua empresa.',
  publisher: {
    '@type': 'Organization',
    name: 'Veritux ERP'
  },
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${url}/?search={search_term_string}`
    },
    'query-input': 'required name=search_term_string'
  }
});

export const getBreadcrumbSchema = (items, url = 'https://www.veritux.com.br') => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url.startsWith('http') ? item.url : `${url}${item.url}`
  }))
});

export const getFAQSchema = (faqs) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map(faq => ({
    '@type': 'Question',
    name: faq.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: faq.answer
    }
  }))
});

export const getProductSchema = (product, url = 'https://www.veritux.com.br') => ({
  '@context': 'https://schema.org',
  '@type': 'Product',
  name: product.name,
  description: product.description,
  brand: {
    '@type': 'Brand',
    name: 'Veritux ERP'
  },
  offers: {
    '@type': 'Offer',
    price: product.price,
    priceCurrency: 'BRL',
    availability: 'https://schema.org/InStock',
    url: `${url}/#precos`,
    priceValidUntil: '2026-12-31'
  }
});

// Schema principal para a landing page
export const getLandingPageSchema = (url = 'https://www.veritux.com.br') => ({
  '@context': 'https://schema.org',
  '@graph': [
    getOrganizationSchema(url),
    getWebSiteSchema(url),
    getSoftwareApplicationSchema(url)
  ]
});

export const getSegmentLandingPageSchema = (
  segment,
  url = 'https://www.veritux.com.br'
) => {
  const segmentConfig = {
    comercio: {
      name: 'Veritux ERP para Comércio',
      description:
        'ERP para pequenos comércios com foco em PDV, controle de caixa, vendas e estoque.',
      featureList: [
        'PDV com venda rápida',
        'Abertura e fechamento de caixa',
        'Fechamento cego de PDV',
        'Relatórios de vendas no balcão',
        'Integração de vendas com estoque'
      ]
    },
    servicos: {
      name: 'Veritux ERP para Serviços e Manutenção',
      description:
        'ERP para empresas de serviços com foco em orçamento, ordem de serviço e faturamento.',
      featureList: [
        'Ordem de serviço com status',
        'Orçamento de serviço com conversão em OS',
        'Histórico de equipamentos e atendimentos',
        'Faturamento de serviços com NFS-e',
        'Relatórios de serviços executados'
      ]
    }
  };

  const selected = segmentConfig[segment] || segmentConfig.comercio;

  return {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(url),
      getWebSiteSchema(url),
      {
        ...getSoftwareApplicationSchema(url),
        name: selected.name,
        description: selected.description,
        featureList: selected.featureList
      }
    ]
  };
};
